import React from 'react';
import TimeSheetPDF from 'timeSheet/components/TimeSheetPDF';
import { useTimesheetLegacyTableColumns } from 'timeSheet/hooks/useTimesheetLegacyTableColumns';

const TimeSheetPDFExport = ({ timesheetProps, userPermissions }) => {
  const {
    showPDF,
    setShowPDF,
    data,
    approveTimeSheet,
    updateOSClientApproval,
    showLockedTimesheetColumn,
    showPayrollProcessFeature,
    showEmployeeSignoffColumn,
    showDateColumn,
    tableContext,
    groupBy,
    showEmployeeRating,
    updateStartTime,
    updateOSStartTime,
    updateEndTime,
    updateOSEndTime,
    showCheckInOutColumns,
    updateCheckInTime,
    updateOSCheckInTime,
    updateCheckOutTime,
    updateOSCheckOutTime,
    showTotalTimeWithoutBreaksColumn,
    updateBreak,
    deleteBreak,
    updateOSBreaks,
    deleteOSBreak,
    updateEmployeeRating,
    updateOSEmployeeRating,
    updateReviewOnEmployee,
    updateOSReviewOnEmployee,
    refetchTimesheet,
    showShiftColumn,
    showTimesheetFields,
    clickableDate,
    isBreakTimesDisplayed
  } = timesheetProps;

  const { hasActionPermission } = userPermissions;

  const pdfColumns = useTimesheetLegacyTableColumns({
    approveTimeSheet,
    updateOSClientApproval,
    setShiftModal: () => {},
    setSelectedEmployee: () => {},
    showLockedTimesheetColumn,
    showPayrollProcessFeature,
    showEmployeeSignoffColumn,
    showDateColumn,
    tableContext,
    groupBy,
    showEmployeeRating,
    updateStartTime,
    updateOSStartTime,
    updateEndTime,
    updateOSEndTime,
    hasActionPermission,
    setIsPromptOpen: () => {},
    showCheckInOutColumns,
    updateCheckInTime,
    updateOSCheckInTime,
    updateCheckOutTime,
    updateOSCheckOutTime,
    showTotalTimeWithoutBreaksColumn,
    updateBreak,
    deleteBreak,
    updateOSBreaks,
    deleteOSBreak,
    updateEmployeeRating,
    updateOSEmployeeRating,
    updateReviewOnEmployee,
    updateOSReviewOnEmployee,
    refetchTimesheet,
    showShiftColumn,
    showTimesheetFields,
    clickableDate,
    isBreakTimesDisplayed
  });

  if (!showPDF) return null;

  return <TimeSheetPDF data={data} columns={pdfColumns} onClose={() => setShowPDF(false)} />;
};

export default TimeSheetPDFExport;
